/* Hakan Hisim conversion instrumentation — additive, reversible layer.
   v6: begin_checkout no longer blocks navigation (v5 preventDefault() + 1.3s
   hold stalled every checkout click and risked losing the sale outright).
   Tracking is now fire-and-forget; the browser proceeds immediately. */
(function(){
  if(window.__omniConversionLayerInstalled) return;
  window.__omniConversionLayerInstalled=true;

  var CHECKOUT_SELECTOR='a[href*="/checkout"],button[name="checkout"],input[name="checkout"]';
  var MAX_WAIT=600;

  function track(name,params){
    try{
      params=params||{};
      if(typeof window.gtag==='function'){ window.gtag('event',name,params); }
      else{
        window.dataLayer=window.dataLayer||[];
        window.dataLayer.push(Object.assign({event:name},params));
      }
      if(window.dataLayer) window.dataLayer.push({event:name,eventModel:params});
    }catch(e){ /* tracking must never block the shopper */ }
  }

  function isCheckoutControl(el){
    return !!(el && el.matches && el.matches(CHECKOUT_SELECTOR));
  }

  function fireBeginCheckout(){
    track('begin_checkout',{
      currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      transport_type:'beacon'
    });
  }

  function markTracked(control){
    if(!control) return;
    control.dataset.omniCheckoutTracked='1';
    window.setTimeout(function(){ delete control.dataset.omniCheckoutTracked; },1500);
  }

  /* Fire the analytics event, then let the default action run untouched. */
  document.addEventListener('click',function(event){
    var control=event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
    if(!isCheckoutControl(control)) return;
    if(control.dataset.omniCheckoutTracked==='1') return;
    markTracked(control);
    fireBeginCheckout();
    /* no preventDefault — navigation continues immediately */
  },true);

  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!form || form.dataset.omniCheckoutReleasing==='1') return;
    var submitter=event.submitter;
    var control=isCheckoutControl(submitter)
      ? submitter
      : form.querySelector('button[name="checkout"],input[name="checkout"]');
    if(!isCheckoutControl(control)) return;
    if(control.dataset.omniCheckoutTracked==='1') return;
    markTracked(control);
    fireBeginCheckout();
    /* no preventDefault — the form submits immediately */
  },true);

  /* Cart-add convenience for programmatic callers (used by theme.js). */
  window.__omniBeginCheckout=function(control,proceed){
    fireBeginCheckout();
    markTracked(control);
    if(typeof proceed==='function'){ proceed(); return true; }
    return false;
  };

  /* Safety net: if a real navigation to checkout is about to happen and the
     event never fired, emit it once. Bounded so it can never loop. */
  window.addEventListener('pagehide',function(){
    try{
      if(window.location.pathname.indexOf('/checkout')!==0) return;
      if(sessionStorage.getItem('omniBcSent')==='1') return;
      sessionStorage.setItem('omniBcSent','1');
      track('begin_checkout',{currency:'USD',transport_type:'beacon'});
    }catch(e){}
  });
})();
